export class Element {
    public __classname__: string = 'Element';

	public ID : string | null = null;
	public Name : string | null = null;
	public LengthWords : number | null = null;
	public LengthChars : number | null = null;
	public LengthParas: number | null = null;
	public LengthLines: number | null = null;
	public Snippet: string | null = null;
	public Version: string | null = null;
	public Content: string | null = null;

    constructor(
        ID: string | null = null,
        Name: string | null = null,
        LengthWords: number | null = null,
        LengthChars: number | null = null,
        LengthParas: number | null = null,
        LengthLines: number | null = null,
        Snippet: string | null = null,
        Version: string | null = null,
        Content: string | null = null
    ) {
        this.ID = ID;
        this.Name = Name;
        this.LengthWords = LengthWords;
        this.LengthChars = LengthChars;
        this.LengthParas = LengthParas;
        this.LengthLines = LengthLines;
        this.Snippet = Snippet;
        this.Version = Version;
        this.Content = Content;
    }
}       